var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"done",attrs:{"index":_vm.taskIndex},on:{"click":_vm.sendDone}},[_vm._v(" Done ")])}
var staticRenderFns = []

export { render, staticRenderFns }